import {NotebookColumnItemType} from 'lookup-config/LookupConfigModalConstants';
import {ColumnDataType, guessColumnDataType} from 'notebook/structured-tables/columns/ColumnDataType';
import {getColumnLabel} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {ColumnConstraint, TableColumnType} from 'notebook/tables/constants/TableColumnConstants';

import {NotebookColumnInfo} from './runLookupConfigModalForNotebook';

export default function extractUsableSourceColumns(
  columnConstraints: Array<ColumnConstraint>
): Array<NotebookColumnInfo> {
  return columnConstraints
    .map(({columnDefinition, structuredTableColumn}): NotebookColumnInfo | null => {
      if (!columnDefinition || !structuredTableColumn) {
        return null;
      }

      const guessedDataType = guessColumnDataType(columnDefinition);
      if (!guessedDataType) {
        return null;
      }
      const baseColumnInfo = {
        name: getColumnLabel(columnDefinition),
        provenanceUuid: structuredTableColumn.provenanceUuid,
        schemaId: guessedDataType.schemaId,
        schemaInterfaceId: guessedDataType.schemaInterfaceId,
      };

      switch (guessedDataType.type) {
        case ColumnDataType.ENTITY:
          return {
            ...baseColumnInfo,
            itemType: NotebookColumnItemType.ENTITY,
          };
        case ColumnDataType.CONTAINER:
          return {
            ...baseColumnInfo,
            itemType: NotebookColumnItemType.CONTAINER,
          };
        case ColumnDataType.PLATE:
          return {
            ...baseColumnInfo,
            itemType: NotebookColumnItemType.PLATE,
          };
        case ColumnDataType.BOX:
          return {
            ...baseColumnInfo,
            itemType: NotebookColumnItemType.BOX,
          };
        case ColumnDataType.LOCATION:
          return {
            ...baseColumnInfo,
            itemType: NotebookColumnItemType.LOCATION,
          };
        case ColumnDataType.STORABLE:
          return {
            ...baseColumnInfo,
            ...(columnDefinition.type === TableColumnType.PARENT_STORABLE && {
              storableLookupMustBeParent: true,
            }),
            itemType: NotebookColumnItemType.STORABLE,
          };
        default:
          return null;
      }
    })
    .filter((notebookColumnInfo): notebookColumnInfo is NotebookColumnInfo => notebookColumnInfo != null);
}
